import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class Utils {

    constructor() { }

    // https://stackoverflow.com/questions/6108819/javascript-timestamp-to-relative-time-eg-2-seconds-ago-one-week-ago-etc-best
    getTime(dateString: string) {
        const msPerMinute = 60 * 1000;
        const msPerHour = msPerMinute * 60;
        const msPerDay = msPerHour * 24;
        const msPerMonth = msPerDay * 30;
        const msPerYear = msPerDay * 365;
        const now = new Date();
        const next = Date.parse(dateString);

        const elapsed = now.getTime() - next;

        if (elapsed < msPerMinute) {
            return 'less than a minute ago';
        }

        else if (elapsed < msPerHour) {
            let value = Math.round(elapsed / msPerMinute)
            if (value == 1) {
                return value + ' minute ago';
            }
            else {
                return value + ' minutes ago';
            }
        }

        else if (elapsed < msPerDay) {
            let value = Math.round(elapsed / msPerHour)
            if (value == 1) {
                return value + ' hour ago';
            }
            else {
                return value + ' hours ago';
            }
        }

        else if (elapsed < msPerMonth) {
            let value = Math.round(elapsed / msPerDay)
            if (value == 1) {
                return value + ' day ago';
            }
            else {
                return value + ' days ago';
            }
        }

        else if (elapsed < msPerYear) {
            let value = Math.round(elapsed / msPerMonth)
            if (value == 1) {
                return value + ' month ago';
            }
            else {
                return value + ' months ago';
            }
        }

        else {
            let value = Math.round(elapsed / msPerYear)
            if (value == 1) {
                return value + ' year ago';
            }
            else if (value > 1) {
                return value + ' years ago';
            }
            else {
                return ""
            }
        }
    }

    static generateGUID(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

}
